import React, { useEffect } from "react";
import "./Pranpratisthapana.scss";
import img9 from "../../src/assets/images/baner-003.png"
import nimantranpatrika from "../../src/assets/images/nimantranpatrika.jpeg"
import nimantranpatrika2 from "../../src/assets/images/nimantranpatrika2.jpeg"
import sevaimage from "../../src/assets/images/sevaimage.png"
import anothernimantranvideo from "../../src/assets/videos/nimantranvideo.mp4"
import qrcodebackground from "../../src/assets/images/qrcbackground.png"
import nimantranvideo from "../../src/assets/videos/dattamandirsohala.mp4"
import { FaPlaceOfWorship } from "react-icons/fa";
import dattatune from "../assets/audio/Datta Digambara Ya Ho-MobCup.vip.mp3"


const PranPratishtaPage = () => {
    useEffect(() => {
        const audio = new Audio(dattatune);
        audio.play().catch(error => console.log("Autoplay blocked", error));
    }, []);

    return (
        <div className="page-container">
            {/* Header Section */}
            <div className="header">
                <h1>II श्रीदत्त मूर्ती प्राणप्रतिष्टा सोहळा II</h1>
                <p>श्रीदत्त मूर्तीची प्राणप्रतिष्ठापना सोहळा <strong>19 फेब्रुवारी ते 2 मार्च</strong></p>
            </div>

            {/* Description Section */}
            <div className="description">
                <p>
                    अयोध्येतील प्रभू श्रीरामाची मूर्ती ज्या शिलेमध्ये बनविलेली आहे त्याच शीलेमध्ये घडविलेल्या श्रीदत्त मूर्तीची प्राणप्रतिष्ठापना
                </p>
            </div>

            {/* Services Section */}
            <div className="nextsection">
                <div className="nimantrampatrika">
                    <img src={nimantranpatrika}></img>
                </div>
                
                {/* <div className="services">
                    <h2>सेवा</h2>
                    <ul>
                        <li><FaPlaceOfWorship /><span>पूजेसाठी सामग्री सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>गुरूचरित्र पारायण सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>दत्तयाग पूजा सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>दत्तमुर्ती प्रतिष्ठापना वेळी मूर्तीच्या खाली ठेवण्यात येणारे सुवर्ण, रौप्य दान</span></li>
                        <li><FaPlaceOfWorship /><span>तुमच्या अथवा परिवारातील सदस्याच्या नावे, स्मरणार्थ दान करावयाचे असल्यास त्या वस्तू अथवा निधी</span></li>
                        <li><FaPlaceOfWorship /><span>सप्ताह करिता ७ दिवस</span></li>
                        <li><FaPlaceOfWorship /><span>महाशिवरात्री १ दिवस</span></li>
                        <li><FaPlaceOfWorship /><span>प्रतिष्ठापना विधी ४ दिवस (असे एकूण १२ दिवस किंवा सोईनुसार अन्नदान सेवा, श्रमदान सेवा)</span></li>
                        <li><FaPlaceOfWorship /><span>हेलिकॉप्टर पुष्पवृष्टी सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>फुलांची सजावट</span></li>
                        <li><FaPlaceOfWorship /><span>मिरवणूक साठी हत्ती</span></li>
                        <li><FaPlaceOfWorship /><span>गंगा मैय्या जलाभिषेक (२ टँकर)</span></li>
                        <li><FaPlaceOfWorship /><span>सप्त सागर जलाभिषेक सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>सप्त नदी जलाभिषेक सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>कलश १००८ (पवित्र नदीचे पोशाखात व महिला पवित्र नदी स्वरूप समजून जलाभिषेक)</span></li>
                        <li><FaPlaceOfWorship /><span>टाळकरी</span></li>
                        <li><FaPlaceOfWorship /><span>लेझिम पथक</span></li>
                        <li><FaPlaceOfWorship /><span>सनई चौघडे</span></li>
                        <li><FaPlaceOfWorship /><span>गायन संगीत सेवा</span></li>
                    </ul>

                </div> */}
                <div className="nimantrampatrika">
                    <img src={sevaimage}></img>
                </div>
                <div className="nimantrampatrika">
                    <img src={nimantranpatrika2}></img>
                </div>
            </div>
            <div className="mobilenextsection">
                <div className="nimantrampatrika">
                    <img src={nimantranpatrika}></img>
                </div>
                
                <div className="nimantrampatrika">
                    <img src={sevaimage}></img>
                </div>
                <div className="nimantrampatrika">
                    <img src={nimantranpatrika2}></img>
                </div>
            </div>
            <div className="videosection">
                <div className="pratishthavideo">
                    <video controls autoPlay loop muted>
                        <source src={nimantranvideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div className="anothernimantran">
                <video controls autoPlay loop muted>
                        <source src={anothernimantranvideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
            <div className="mobilevideosection">
                <div className="pratishthavideo">
                    <video controls autoPlay loop muted>
                        <source src={nimantranvideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div className="anothernimantran">
                <video controls autoPlay loop muted>
                        <source src={anothernimantranvideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>


            {/* <div className="mobile-nextsection">
                <div className="services">
                    <h2>सेवा</h2>
                    <ul>
                        <li><FaPlaceOfWorship /><span>पूजेसाठी सामग्री सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>गुरूचरित्र पारायण सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>दत्तयाग पूजा सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>दत्तमुर्ती प्रतिष्ठापना वेळी मूर्तीच्या खाली ठेवण्यात येणारे सुवर्ण, रौप्य दान</span></li>
                        <li><FaPlaceOfWorship /><span>तुमच्या अथवा परिवारातील सदस्याच्या नावे, स्मरणार्थ दान करावयाचे असल्यास त्या वस्तू अथवा निधी</span></li>
                        <li><FaPlaceOfWorship /><span>सप्ताह करिता ७ दिवस</span></li>
                        <li><FaPlaceOfWorship /><span>महाशिवरात्री १ दिवस</span></li>
                        <li><FaPlaceOfWorship /><span>प्रतिष्ठापना विधी ४ दिवस (असे एकूण १२ दिवस किंवा सोईनुसार अन्नदान सेवा, श्रमदान सेवा)</span></li>
                        <li><FaPlaceOfWorship /><span>हेलिकॉप्टर पुष्पवृष्टी सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>फुलांची सजावट</span></li>
                        <li><FaPlaceOfWorship /><span>मिरवणूक साठी हत्ती</span></li>
                        <li><FaPlaceOfWorship /><span>गंगा मैय्या जलाभिषेक (२ टँकर)</span></li>
                        <li><FaPlaceOfWorship /><span>सप्त सागर जलाभिषेक सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>सप्त नदी जलाभिषेक सेवा</span></li>
                        <li><FaPlaceOfWorship /><span>कलश १००८ (पवित्र नदीचे पोशाखात व महिला पवित्र नदी स्वरूप समजून जलाभिषेक)</span></li>
                        <li><FaPlaceOfWorship /><span>टाळकरी</span></li>
                        <li><FaPlaceOfWorship /><span>लेझिम पथक</span></li>
                        <li><FaPlaceOfWorship /><span>सनई चौघडे</span></li>
                        <li><FaPlaceOfWorship /><span>गायन संगीत सेवा</span></li>
                    </ul>

                </div>
            </div> */}



            {/* Contact Section */}
            <div className="contact">
                <h2>योगदान करा</h2>
                <p>शक्य असल्यास तन मन धन माध्यमाने  सेवेमध्ये सहभागी होऊन श्रीदत्त कृपेचा अनुभव घ्यावा.</p>
                <p>आपणास कोणतीही सेवा करायची असल्यास संपर्क साधा किंवा थेट मंदिराच्या बँक खात्यामध्ये समर्पण करा.</p>
                {/* <button>संपर्क करा</button> */}
            </div>
            <center>
                <div className="qrcode">
                    <img src={qrcodebackground}></img>
                </div>
            </center>
            <div className="qrcode-mobile">
                <img src={qrcodebackground}></img>
            </div>
            <center>
                <div className="viewallphoto">
                    <button className="viewallphotobutton" onClick={() => window.location.href = "/donation"}>
                        Donate Now
                    </button>
                </div>

            </center>

        </div>
    );
};

export default PranPratishtaPage;
